import { Button, Typography } from "antd";
import React, { useState } from "react";
import ModalOTP from "./ModalOTP";

const Index = ({
  mobile = "",
  email = "",
  partnerCode = "",
  partnerType = "",
  isMainMarried = 0,
  setMobileToVerify = () => null,
  setMobileLocalStored = () => null,
}) => {
  const [visible, setVisible] = useState(false);
  const disabled = !mobile || mobile === "invalid mobile number";
  const storedMobile =
    JSON.parse(localStorage.getItem("mobileLocalStored")) || {};

  return (
    <>
      <Typography.Text className="mr-2">
        ({partnerCode} : {mobile})
      </Typography.Text>
      <Button
        disabled={
          disabled ||
          (storedMobile[mobile] !== undefined && storedMobile[mobile] === false)
        }
        size="small"
        className={
          !disabled &&
          (storedMobile[mobile] === undefined || storedMobile[mobile] === true)
            ? "bg-nn border-nn text-white"
            : "d-none"
        }
        onClick={() => setVisible(true)}
      >
        ยืนยัน
      </Button>
      {!disabled && (
        <ModalOTP
          visible={visible}
          data={{
            mobile,
            email,
            partner_code: partnerCode,
            partner_type: partnerType,
            is_main_married: isMainMarried,
          }}
          onCancel={() => setVisible(false)}
          onOk={() => {
            setVisible(false);

            setMobileLocalStored((prev) => {
              const updated = {
                ...prev,
                [mobile]: false,
              };
              return updated;
            });

            setTimeout(() => {
              setMobileToVerify(null);
            }, 300);
          }}
        />
      )}
    </>
  );
};

export default Index;
